module.exports = __webpack_public_path__ + "static/projects-preview-3e48578c36bdc3886aced6b7289a460c.jpg";